import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiVisa, Core2Config } from '../../shared';
import { UserAgreementDocumentContainerModel } from '../../../../../../models';
import { Observable } from 'rxjs';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({ providedIn: 'root' })

export class WebsiteUserAgreementService extends BaseApiPublicLoginTemplateService<UserAgreementDocumentContainerModel, UserAgreementDocumentContainerModel, UserAgreementDocumentContainerModel> {
  endpointSubPath = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'website-user-agreement-document-hdr';
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + this.endpointSubPath + '/backoffice-ep';
    this.endpoint_path = this.endpointSubPath + '/backoffice-ep';
    this.endpoint_path_public_url = this.endpointSubPath + '/public-ep';
    this.endpoint_path_login_url = this.endpointSubPath + '/login-ep';
    this.httpClient = http;
  }
  
  createUserAgreementDocWithFile(formData: FormData, visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + this.endpoint_path;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }

  updateUserAgreementDocWithFile(formData: FormData, visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + this.endpoint_path;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  updateFile(formData: FormData, docHdrGuid, visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + this.endpoint_path + '/replace-file/' + docHdrGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/replace-file/' + docHdrGuid;
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  getFile(guid: string, visa: ApiVisa): Observable<Blob> {
    let url = Core2Config.DOMAIN_URL + this.endpoint_path + '/file/' + guid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/file/' + guid;
    }
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }

  getFilePublicEp(guid: string, visa: ApiVisa): Observable<Blob> {
    let url = Core2Config.DOMAIN_URL + this.endpoint_path_public_url + '/file/' + guid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path_public_url + '/file/' + guid;
    }
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }

  getFileLoginEp(guid: string, visa: ApiVisa): Observable<Blob> {
    let url = Core2Config.DOMAIN_URL + this.endpoint_path_login_url + '/file/' + guid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path_login_url + '/file/' + guid;
    }
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }
}